import { ref, readonly } from 'vue'
import type { Ref } from 'vue'
import Leads from '@/api/leads.js'

export interface LeadData {
  onboarding: {
    id: string
    name: string
  }
  account: {
    name: string
    postalcode: string
    app_branding: string
    timetable_provider: string
    student_count: number
    teacher_count: number
    address: string
    city: string
    country: string
    license_count: number
  }
  cs_contacts: Array<{
    email: string;
    id: number;
    meta: { displayname: string }
  }>
  school_contacts: Array<{
    school_contact_id: number
    school_contact_name: string
    school_contact_email: string
  }>
  school_types: Array<{ key: string; name: string }>
}

const leadData = ref<LeadData | null>(null)

export function useLeadData() {
  const setLeadData = (data: LeadData) => {
    leadData.value = data
  }

  const fetchLeadData = async (onboardingName: string) => {
    const { data } = await Leads.getOnboardingsByName({ params: { name: onboardingName }})
    if (!data) return
    setLeadData(data)
  }

  return {
    leadData: readonly(leadData) as Readonly<Ref<LeadData | null>>,
    fetchLeadData,
  }
}
